const VAActionType = {
  GET_VA_CONFIG: 'GET_VA_CONFIG'
};

export default VAActionType;



/** WEBPACK FOOTER **
 ** ./src/common/VAActionType.js
 **/